module.exports = __webpack_public_path__ + "img/b4.d36e2482.png";